import { render, staticRenderFns } from "./TenancyPaymentsView.vue?vue&type=template&id=43790e8e&"
import script from "./TenancyPaymentsView.vue?vue&type=script&lang=js&"
export * from "./TenancyPaymentsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports